export default "__VITE_ASSET__CTIagm74__$_?nuxt_component=async&nuxt_component_name=IconFrameShapeSonstige&nuxt_component_export=default__"